import { IFinancialTableData } from './financial-table-data.interface';

export interface IBalanceSheetData {
    assets?: IFinancialTableData[] | null;
    liabilitiesAndEquity?: IFinancialTableData[] | null;
    liabilities?: IFinancialTableData[] | null;
    equity?: IFinancialTableData[] | null;
}
